import { LabelTemplate } from "./LabelDocumentModel";
import Template1 from "./templates/template-1.json";
import Template2 from "./templates/template-2.json";


export const templates = [
    Template1,
    Template2,
] as LabelTemplate[];

